import { dashboardActions } from '../actionTypes';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `dashboardReducer.js`);

/* -------- initial state -------- */
const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {

    /* ----- post lead report  ----- */
    case dashboardActions.POST_REPORT_LEADS_REQUEST:
      return state;

    case dashboardActions.POST_REPORT_LEADS_FAILURE:
      return state;

    case dashboardActions.POST_REPORT_LEADS_SUCCESS:
      return state;

      /* -------- post ids report -------- */
    case dashboardActions.POST_REPORT_AGENCIES_REQUEST:
      return state;

    case dashboardActions.POST_REPORT_AGENCIES_FAILURE:
      return state;

    case dashboardActions.POST_REPORT_AGENCIES_SUCCESS:
      return state;


    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/data/dashboard/dashboardReducer.js